<script setup lang="ts">
import type { BusinessType } from "~/types";

interface Props {
  businessTypes: BusinessType[];
}

defineProps<Props>();

const { t } = useI18n();

const selectedBusinessType = defineModel("selectedBusinessType", {
  type: String,
});
</script>

<template>
  <div class="flex flex-col justify-center items-center space-y-1 lg:space-y-3">
    <h2
      class="text-navy-500 font-bold text-center text-2xl lg:text-[40px] leading-[30px] lg:leading-[46px]"
    >
      {{ t("page.create_business.business_type.title") }}
    </h2>
    <span
      class="text-overcast-night font-medium text-wrap text-center text-sm lg:text-lg"
      >{{ t("page.create_business.business_type.desc") }}</span
    >
  </div>

  <div class="grid grid-cols-3 gap-4 w-full md:min-w-[500px] mx-auto mt-10">
    <div
      v-for="(businessType, index) in businessTypes"
      :key="index"
      class="p-5 w-full max-w-45 mx-auto h-32 md:h-40 lg:h-40 flex items-center ring-1 ring-inset ring-crystal-falls hover:ring-sky-blue gap-x-2 px-3.5 py-3 rounded-2xl cursor-pointer transition-all"
      :class="{
        'ring-2 ring-sky-blue': selectedBusinessType === businessType?.value,
      }"
      @click="selectedBusinessType = businessType?.value"
    >
      <div class="flex-1 flex flex-col justify-center items-center space-y-4">
        <img
          :src="businessType?.icon"
          :alt="businessType?.name"
          :class="businessType?.name"
          class="size-10 md:size-12 lg:size-15"
        >
        <p class="text-default-500 text-center text-sm block capitalize">
          {{ businessType?.name }}
        </p>
      </div>
    </div>
  </div>
</template>
